import { useQuery } from '@tanstack/react-query';
import { AdminAPI } from '@shared/types/api';
import { api } from '@/lib/api';

interface UseAdminReferralsParams {
  page?: number;
  limit?: number;
  status?: 'all' | 'pending' | 'used' | 'rewarded';
  refetchInterval?: number | false;
}

export function useAdminReferrals(params: UseAdminReferralsParams = {}) {
  const { page = 1, limit = 25, status = 'all', refetchInterval } = params;
  
  return useQuery<AdminAPI.GetReferralsResponse, Error>({
    queryKey: ['admin', 'referrals', page, limit, status],
    refetchInterval,
    queryFn: async (): Promise<AdminAPI.GetReferralsResponse> => {
      const searchParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        status,
      });
      return api.get(`/admin/referrals?${searchParams.toString()}`);
    },
  });
}

